import { useEffect, useRef } from "react";
import { useLocation } from "react-router-dom";
import { track } from "@/lib/analytics";

const IGNORE = ["/admin", "/auth/callback"];

// Tracks page views on route change, sends a heartbeat for "live users",
// and logs outbound/affiliate link clicks — all first-party.
export default function AnalyticsTracker() {
  const { pathname } = useLocation();
  const heartbeat = useRef(null);

  const ignored = IGNORE.some((p) => pathname.startsWith(p));

  useEffect(() => {
    if (ignored) return;
    track("pageview");
  }, [pathname, ignored]);

  useEffect(() => {
    if (ignored) return;
    track("heartbeat");
    heartbeat.current = setInterval(() => track("heartbeat"), 30000);
    return () => clearInterval(heartbeat.current);
  }, [pathname, ignored]);

  useEffect(() => {
    const onClick = (e) => {
      const a = e.target.closest && e.target.closest("a[href]");
      if (!a) return;
      const href = a.getAttribute("href") || "";
      if (!/^https?:\/\//i.test(href)) return; // only outbound
      let host = href;
      try { host = new URL(href).hostname.replace("www.", ""); } catch (_) {}
      if (host && !host.includes(window.location.hostname)) {
        track("click", { target: host, label: a.dataset.affTitle || "", kind: a.dataset.affKind || "" });
      }
    };
    document.addEventListener("click", onClick, true);
    return () => document.removeEventListener("click", onClick, true);
  }, []);

  return null;
}
